import React from 'react';

export default function ThoughtModal({ visible, thoughtContent, onChange, onSave, onCancel, isEditing }) {
    if (!visible) return null;

    const wordCount = thoughtContent.trim().split(/\s+/).filter(Boolean).length;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded p-6 shadow w-80">
                <h2 className="text-xl font-semibold mb-2">{isEditing ? 'Edit Thought' : 'New Thought'}</h2>
                <textarea
                    value={thoughtContent}
                    onChange={(e) => onChange(e.target.value)}
                    maxLength={500}
                    minLength={1}
                    rows={3}
                    placeholder="Max 30 words..."
                    className="w-full border p-2 rounded mb-2"
                />
                <p className="text-sm text-gray-500 mb-2">
                    {wordCount} / 30 words
                </p>
                <div className="flex justify-between">
                    <button onClick={onCancel} className="px-3 py-1 border rounded">Cancel</button>
                    <button
                        onClick={onSave}
                        className="bg-accent text-white px-3 py-1 rounded"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
}